'use client';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState } from 'react';
import { Button } from './Button';
import { Dialog as ShadDialog, DialogContent, DialogHeader, DialogTitle } from './ui/dialog';
import { useReturnFocus } from './useReturnFocus';
export function Modal({ open, onClose, title, children, actions, dirty = false, wide = false, confirmId, }) {
    const [asking, setAsking] = useState(false);
    const returnFocus = useReturnFocus(open);
    /** Попытка закрыть: у окна с правками она превращается в вопрос. */
    const tryClose = () => {
        if (dirty) {
            setAsking(true);
            return;
        }
        onClose();
    };
    return (_jsx(ShadDialog, { open: open, onOpenChange: (next) => {
            if (!next)
                tryClose();
        }, children: _jsxs(DialogContent, { "data-modal-open": open ? 'true' : 'false', "data-confirm": confirmId, "aria-label": typeof title === 'string' ? title : undefined, 
            /*
             * ПРОКРУТКА ТЕЛА - у окна, а не у содержимого.
             *
             * Потолок высоты даёт примитив окна (высота экрана минус полоса
             * тостов), а здесь - что делать, когда содержимое выше потолка:
             * шапка и кнопки остаются на месте, прокручивается тело. Без этого
             * окно росло за экран и кнопки уезжали за нижнюю кромку - широкий
             * редактор привязок перестал закрываться, и это поймали ворота
             * панели игры.
             */
            className: `grid-rows-[auto_minmax(0,1fr)_auto] gap-4 ${wide ? 'max-w-3xl' : 'max-w-lg'}`, onCloseAutoFocus: returnFocus, onInteractOutside: (event) => {
                /* СТОРОЖ ПОДЛОЖКИ: нажатие мимо окна с правками не закрывает его, а
                   задаёт вопрос. Библиотека закрыла бы молча. */
                if (dirty) {
                    event.preventDefault();
                    setAsking(true);
                }
            }, children: [_jsx(DialogHeader, { children: _jsx(DialogTitle, { "data-dialog-title": true, className: "text-xl", children: title }) }), _jsx("div", { className: "text-muted-foreground min-h-0 overflow-y-auto", children: children }), _jsx("div", { className: "flex flex-wrap items-center justify-end gap-2", children: asking ? (_jsxs("div", { "data-modal-guard": true, className: "flex w-full flex-wrap items-center gap-2", children: [_jsx("span", { className: "text-foreground min-w-0 flex-1 text-sm font-medium", children: "\u0415\u0441\u0442\u044C \u043D\u0435\u0441\u043E\u0445\u0440\u0430\u043D\u0451\u043D\u043D\u044B\u0435 \u043F\u0440\u0430\u0432\u043A\u0438. \u0417\u0430\u043A\u0440\u044B\u0442\u044C \u0431\u0435\u0437 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F?" }), _jsx(Button, { variant: "secondary", size: "s", "data-modal-guard-stay": true, onClick: () => {
                                    setAsking(false);
                                }, children: "\u041F\u0440\u043E\u0434\u043E\u043B\u0436\u0438\u0442\u044C \u043F\u0440\u0430\u0432\u043A\u0443" }), _jsx(Button, { variant: "danger-solid", size: "s", "data-modal-guard-close": true, onClick: () => {
                                    setAsking(false);
                                    onClose();
                                }, children: "\u0417\u0430\u043A\u0440\u044B\u0442\u044C \u0431\u0435\u0437 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u0438\u044F" })] })) : (actions) })] }) }));
}
//# sourceMappingURL=Modal.js.map